import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { ComposeOperation } from '../store/schema/ComposeViewState';
import { format } from 'owa-strings';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isSignatureEnabled } from 'mini-mail-signature';
import {
    isMailSignatureCloudSettingsInitialized,
    getEffectiveRoamingNewSignature,
    getEffectiveRoamingReplySignature,
} from 'mini-mail-signature-cloud-settings';

const defaultContentBlock = '<div><br/></div>';

export function shouldAutoAddSignature(operation: ComposeOperation): boolean {
    return isSignatureEnabled() && operation !== ComposeOperation.EditDraft;
}

export function getSignatureBlock(operation: ComposeOperation): string {
    // when roaming cloud signature settings is disabled, use the old signature as fallback
    if (!isRoamingSignatureEnabled()) {
        const userOptions = getUserConfiguration().UserOptions;
        return userOptions?.SignatureHtml || '';
    }

    const signature: string = isReplyOrForwardScenario(operation)
        ? getReplyOrForwardSignature()
        : getComposeSignature();

    return signature
        ? defaultContentBlock + defaultContentBlock + format('<div>{0}</div>', signature)
        : '';
}

function getReplyOrForwardSignature(): string {
    if (!isSignatureEnabled()) {
        return '';
    }

    // when user has cloud signature settings enabled
    if (isMailSignatureCloudSettingsInitialized()) {
        return getEffectiveRoamingReplySignature();
    }

    // for the user who has not setup signatures in big OWA
    return '';
}

function getComposeSignature(): string {
    if (!isSignatureEnabled()) {
        return '';
    }

    // when user has cloud signature settings enabled
    if (isMailSignatureCloudSettingsInitialized()) {
        return getEffectiveRoamingNewSignature();
    }
    return '';
}

function isReplyOrForwardScenario(operation: ComposeOperation) {
    return [
        ComposeOperation.Reply,
        ComposeOperation.ReplyAll,
        ComposeOperation.Forward,
        ComposeOperation.ForwardCalendarEvent,
    ].includes(operation);
}

export function isRoamingSignatureEnabled() {
    return (
        isFeatureEnabled('cmp-roaming-signature') &&
        !getUserConfiguration().SessionSettings?.IsExplicitLogon
    );
}
